import React, { Component } from 'react'
import { connect } from 'react-redux'

import { actualizarDatosParaMuiTable } from '../actions/TablaDetallePorCerealLinea12Actions'
import { TablaDetallePorCerealLinea12View } from '../components/TablaDetallePorCerealLinea12View'

class TablaDetallePorCerealLinea12 extends Component {
  componentDidMount () {
    this.props.actualizarDatosParaMuiTable()
  }

  render () {
    return <TablaDetallePorCerealLinea12View />
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(TablaDetallePorCerealLinea12)
